// extracted by mini-css-extract-plugin
export default {"container":"Cart_container__C0yf7","item":"Cart_item__k2oRm","img":"Cart_img__ayiSX","title":"Cart_title__Ii1uN","price":"Cart_price__QjalO"};